import React, { CSSProperties, FormEvent, FormEventHandler, KeyboardEvent, KeyboardEventHandler } from 'react'
import classes from './Select.module.css'

type InputType = {
	type?: string
	value: string
	oninput?: (str: string) => void
	placeholder?: string
	title?: string
	style?: CSSProperties
	keyDown?: (e: KeyboardEvent<HTMLInputElement>) => void
}

function Input({ type = 'text', value = '', oninput = () => {}, placeholder = '', title = '', style = {}, keyDown }: InputType) {
	return (
		<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
			<label className={classes.inp_label}>{title}</label>
			<input
				type={type}
				placeholder={placeholder}
				style={style}
				value={value}
				className={classes.input}
				onInput={(event: FormEvent<HTMLInputElement>) => {
					oninput(event.currentTarget.value)
				}}
				onKeyDown={keyDown ? keyDown : (event: KeyboardEvent<HTMLInputElement>) => {}}
			/>
		</div>
	)
}

export default Input
